import { connect } from 'react-redux';
import mapProfileToProps from 'profile/containers/map_profile_to_props';
import Stats from 'profile/components/stats';

export default connect(mapProfileToProps)(Stats);



// WEBPACK FOOTER //
// ./profile/containers/stats.js